import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=c0a39cbc&"
import script from "./CategoryList.vue?vue&type=script&lang=js&"
export * from "./CategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports